module.exports = __webpack_public_path__ + "img/business.58bb3852.svg";